import Component from '@glimmer/component'
import BaseHighcharterComponent from 'teacher-ui-client/components/base/highcharter'
import type * as HighCharts from 'highcharts'

export interface TooltipConfig {
  enabled: boolean
  backgroundColor: string
  borderWidth: number
  borderRadius: number
  shadow: boolean
  formatter: () => string
  style: {
    color: string
  }
}

interface Args {
  colors: string[]
  tooltip?: TooltipConfig
  subtitle: string
  innerSize: string
  size: string
  data: Array<HighCharts.SeriesPieOptions>
}

interface Signature {
  Element: HTMLDivElement
  Args: Args
}

export class PieChart extends Component<Signature> {
  chartMargin = 0

  chartSpacing = [10, 10, 10, 10]

  verticalAlign: HighCharts.VerticalAlignValue = 'middle'

  get chartOptions(): HighCharts.Options {
    const disabled = { enabled: false }
    const { colors, subtitle, plotOptions } = this
    const backgroundColor = 'transparent'
    const options = {
      colors,
      chart: {
        type: 'pie',
        backgroundColor,
        margin: this.chartMargin,
        spacing: this.chartSpacing,
      },
      credits: disabled,
      plotOptions,
      tooltip: this.args.tooltip,
      title: undefined,
      subtitle,
      legend: disabled,
    }
    return options
  }

  get colors() {
    return this.args.colors
  }

  get highchartsOptions(): HighCharts.Options {
    return { ...this.chartOptions, series: this.args.data }
  }

  get plotOptions() {
    return {
      pie: {
        innerSize: this.args.innerSize,
        size: this.args.size,
      },
    }
  }

  get subtitle(): HighCharts.SubtitleOptions {
    return {
      text: this.args.subtitle,
      verticalAlign: this.verticalAlign,
      style: {
        fontSize: '3rem',
        fontWeight: '300',
      },
    }
  }
  <template><BaseHighcharterComponent class="h-full" @options={{this.highchartsOptions}} ...attributes /></template>
}

export default PieChart
